
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Profile Details</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="#">Home</a></li>
              <li class="breadcrumb-item active">Profile</li>
            </ol>
          </div>
        </div>
      </div><!-- /.container-fluid -->
    </section>

    <!-- Main content -->
    <section class="content">
          
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-3">

            <!-- Profile Image -->
            <div class="card card-danger card-outline">
              <div class="card-body box-profile">
                <div class="text-center">
                  <img class="profile-user-img img-fluid img-circle"
                       src="{{primagepath}}"
                       alt="User profile picture">
                </div>

                <h3 class="profile-username text-center">{{objprof.stunm}}</h3>

                <p class="text-muted text-center">{{objprof.clnm}} - {{objprof.crnm}}</p>

                <ul class="list-group list-group-unbordered mb-3">
                  <li class="list-group-item">
                    <b>Age</b> <a class="float-right">{{objprof.Age}}</a>
                  </li>
                  <li class="list-group-item">
                    <b>Blood Group</b> <a class="float-right">{{objprof.bgnm}}</a>
                  </li>
                  <li class="list-group-item">
                    <b>Mobile</b> <a class="float-right">{{objprof.stumobile}}</a>
                  </li>

                  <li class="list-group-item" style="align-self: center;">
                    <button type="submit" class="btn btn-danger" (click)="openprofileupload(proupload)">Upload Profile</button>
                  </li>
                </ul>

                <!-- <a href="#" class="btn btn-danger btn-block"><b>Follow</b></a> -->
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->

            <!-- About Me Box -->
            <div class="card card-danger">
              <div class="card-header">
                <h3 class="card-title">About Me</h3>
              </div>
              <!-- /.card-header -->
              <div class="card-body">
                <strong><i class="fas fa-book mr-1"></i> Address</strong>

                <p class="text-muted">
                  {{objprof.address}}
                </p>

                <hr>

                <strong><i class="fas fa-map-marker-alt mr-1"></i> Location</strong>

                <p class="text-muted">{{objprof.city}} {{objprof.state}} {{objprof.country}} {{objprof.pin}}</p>

               

               

              
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
          <!-- /.col -->
          <div class="col-md-6">
            <div class="card card-danger card-outline">
              <div class="card-header p-2" >
                <ul class="nav nav-pills">
                  <li class="nav-item"><a class="nav-link active" href="#perinfo" data-toggle="tab"  >Personal Info</a></li>
                  <li class="nav-item"><a class="nav-link " href="#Oinfo" data-toggle="tab"  >Family Info</a></li>
                  <li class="nav-item"><a class="nav-link " href="#pp" data-toggle="tab">Professional Info</a></li>
                  <!-- <li class="nav-item"><a class="nav-link" href="#Pass" data-toggle="tab">Reset Password</a></li> -->
               
                </ul>
              </div><!-- /.card-header -->
              <div class="card-body">
                <div class="tab-content">
                  <div class="active tab-pane" id="perinfo">
                    <form name="frmper" #formDir="ngForm">
                      <div class="form-group ">
                        <label for="inputName" >Name</label>
                     
                        <input class="form-control" name="stunm" type="text" placeholder="Student Name"  [(ngModel)]="objprof.stunm" #stunm="ngModel" />
                   
                      </div>
                      <div class="row"><div class="col-md-6"><div class="form-group " >
                        <label for="inputName" >Date Of Birth</label>
                        
                        <input class="form-control" name="dob" [(ngModel)]="objprof.dob" #dob="ngModel" type="Date" placeholder="DOB" />
                         
                      </div></div><div class="col-md-6"><div class="form-group ">
                        <label for="inputEmail" >Blood Group</label>
                        <select class="form-control" name="bgid" [(ngModel)]="objprof.bgid" #bgid="ngModel" >
                          <option [ngValue]="k.blgpid" *ngFor="let k of bloodgp">
                              {{k.blgpnm}}
                            </option>
                         
                      </select>
                        
                  
                      </div></div></div>
                      

                      

                      <div class="form-group ">
                        <label for="inputName">Mobile</label>
                       
                        <input class="form-control" name="stumobile" [(ngModel)]="objprof.stumobile" #stumobile="ngModel" type="text" placeholder="Student Mobile" />
                
                      </div>

                      <div class="form-group ">
                        <label for="inputEmail" >Email</label>
                      
                        <input class="form-control" name="stuemail" [(ngModel)]="objprof.stuemail" #stuemail="ngModel" type="text" placeholder="Student Email" />
                      
                      </div>

                     
                      <div class="form-group ">
                        <label for="inputExperience" >Address</label>
                       
                        <textarea  rows="4" class="form-control" name="address" [(ngModel)]="objprof.address" #address="ngModel"    placeholder="Address"></textarea>
                       
                      </div>
                      

                      <div class="form-group ">
                        <label for="inputSkills" >City</label>
                       
                        <input class="form-control" name="city" [(ngModel)]="objprof.city" #city="ngModel"  type="text" placeholder="City" />
                       
                      </div>
                      <div class="form-group ">
                        <label for="inputSkills" >Pin Code</label>
                        
                        <input class="form-control" name="pin" [(ngModel)]="objprof.pin" #pin="ngModel" type="text" placeholder="Pin Code" />
                      
                      </div>
                     


                    


                     
                     
                    

                    
                      <div class="form-group ">
                     
                          <!-- <button type="submit" class="btn btn-danger" (click)="save_profileinfo('pers')">Save Details</button> -->
                 
                      </div>
                    </form>
                  </div>
                  <!-- /.tab-pane -->
                  <div class=" tab-pane" id="Oinfo">
                    <form name="frmparent" #formDir="ngForm">
                  

                      <div class="form-group ">
                        <label for="inputName" >Father Name</label>
                        
                        <input class="form-control" name="fatnm" [(ngModel)]="objprof.fatnm" #fatnm="ngModel" type="text" placeholder="Father Name" />
                      
                      </div>

                      <div class="row"><div class="col-md-6"> <div class="form-group ">
                        <label for="inputName" >Father Mobile</label>
                       
                        <input class="form-control" name="fatmobile" [(ngModel)]="objprof.fatmobile" #fatmobile="ngModel" type="text" placeholder="Father Mobile" />
                       
                      </div></div><div class="col-md-6"><div class="form-group ">
                        <label for="inputEmail" >Father Email</label>
                      
                        <input class="form-control" name="fatemail" [(ngModel)]="objprof.fatemail" #fatemail="ngModel" type="text" placeholder="Father Email" />
                    
                      </div></div></div>
                     

                      

                      <div class="form-group ">
                        <label for="inputName" >Mother Name</label>
                      
                        <input class="form-control" name="motnm" [(ngModel)]="objprof.motnm" #motnm="ngModel" type="text" placeholder="Mother Name" />
                    
                      </div>

                      <div class="row"><div class="col-md-6"><div class="form-group ">
                        <label for="inputName" >Mother Mobile</label>
                        
                        <input class="form-control" name="motmobile" [(ngModel)]="objprof.motmobile" #motmobile="ngModel" type="text" placeholder="Mother Mobile" />
                       
                      </div></div><div class="col-md-6"> <div class="form-group ">
                        <label for="inputEmail" >Mother Email</label>
                       
                        <input class="form-control" name="motemail" [(ngModel)]="objprof.motemail" #motemail="ngModel" type="text" placeholder="Mother Email" />
                        
                      </div></div></div>

                      

                     


                    


                     
                    

                   
                      <div class="form-group ">
                        
                          <!-- <button type="submit" class="btn btn-danger" (click)="save_profileinfo('family')">Save Details</button> -->
                       
                      </div>
                    </form>
                  </div>
                  <!-- /.tab-pane -->


                  <div class=" tab-pane" id="pp">
             
                    <!-- <div class="row"><div class="col-md-6"></div><div class="col-md-6"></div></div> -->
                    <div class="row"><div class="col-md-6"> <div class="form-group ">
                    <label for="inputExperience" >Hobbies/Co-Curricular Activities</label>
                   
                    <textarea  rows="3" class="form-control" name="hob" [(ngModel)]="objprof.hobbies" #hob="ngModel"    placeholder="Hobbies/Co-Curricular Activities"></textarea>
                   
                  </div></div><div class="col-md-6"><div class="form-group ">
                    <label for="inputExperience" >Achievements</label>
                   
                    <textarea  rows="3" class="form-control" name="Achievements" [(ngModel)]="objprof.achievements" #Achievements="ngModel"    placeholder="Achievements"></textarea>
                   
                  </div></div></div>
                 

                  <div class="row"><div class="col-md-6"><div class="form-group ">
                    <label for="inputExperience" >Goals</label>
                   
                    <textarea  rows="3" class="form-control" name="Goals" [(ngModel)]="objprof.goals" #Goals="ngModel"    placeholder="Goals"></textarea>
                   
                  </div></div><div class="col-md-6"><div class="form-group ">
                    <label for="inputExperience" >Carrier Options</label>
                   
                    <textarea  rows="3" class="form-control" name="caropt" [(ngModel)]="objprof.careeroptn" #caropt="ngModel"    placeholder="Carrier Options"></textarea>
                   
                  </div></div></div>

                  

                  

                  <div class="form-group ">
                    <label for="inputExperience" >
                      Language(s) To Speak</label>
                   
                    <textarea  rows="2" class="form-control" name="lanspeak" [(ngModel)]="objprof.lantospeak" #lanspeak="ngModel"    placeholder="Language(s) To Speak"></textarea>
                   
                  </div>

                  <div class="form-group ">
                    <label for="inputExperience" >
                      Language(s) To Read</label>
                   
                    <textarea  rows="2" class="form-control" name="lanread" [(ngModel)]="objprof.lantoread" #lanread="ngModel"    placeholder="Language(s) To Read"></textarea>
                   
                  </div>

                  <div class="form-group ">
                    <label for="inputExperience" >
                      Language(s) To Write</label>
                   
                    <textarea  rows="2" class="form-control" name="lanwrite" [(ngModel)]="objprof.lantowrite" #lanwrite="ngModel"    placeholder="Language(s) To Write"></textarea>
                   
                  </div>
                       
                  <div class="row"><div class="col-md-6"> <div class="form-group ">
                    <label for="inputName" >Qualifying UG Course</label>
                    
                    <!-- <input class="form-control" name="qcrid" [(ngModel)]="objprof.qcrid" #qcrid="ngModel" type="text" placeholder="Father Name" /> -->
                    <select class="form-control" name="qcrid" [(ngModel)]="objprof.qcrid" #qcrid="ngModel" >
                      <option [ngValue]="k.crid" *ngFor="let k of arrcourse">
                          {{k.crnm}}
                        </option>
                     
                  </select>
                  </div></div><div class="col-md-6"><div class="form-group ">
                    <label for="inputName" >Institute Name</label>
                    
                    <input class="form-control" name="qinnm" [(ngModel)]="objprof.qinnm" #qinnm="ngModel" type="text" placeholder="Institute Name" />
                  
                  </div></div></div>
                 

                  <div class="row"><div class="col-md-6"><div class="form-group ">
                    <label for="inputName" >Electives</label>
                    
                    <input class="form-control" name="qcrelsubj" [(ngModel)]="objprof.qcrelective" #qcrelsubj="ngModel" type="text" placeholder="Electives" />
                  
                  </div></div><div class="col-md-6"><div class="form-group ">
                    <label for="inputName" >Year of Passing</label>
                    
                    <input class="form-control" name="qyop" [(ngModel)]="objprof.qcryop" #qyop="ngModel" type="number" placeholder="Year of Passing" />
                  
                  </div></div></div>

                  

                  
                  <div class="row"><div class="col-md-6"> <div class="form-group ">
                    <label for="inputName" >Aggregate</label>
                    
                    <input class="form-control" name="qagpct" [(ngModel)]="objprof.qcragpct" #qagpct="ngModel" type="number" placeholder="Aggregate" />
                  
                  </div></div><div class="col-md-6"> <div class="form-group ">
                    <label for="inputName" >Core Subject Aggregate</label>
                    
                    <input class="form-control" name="qcspct" [(ngModel)]="objprof.qcrcspct" #qcspct="ngModel" type="number" placeholder="Core Subject Aggregate" />
                  
                  </div></div></div>
                 

                 

                 

                  <div class="form-group ">
                    <label for="inputName" >Worked Company</label>
                    
                    <input class="form-control" name="wkcompany" [(ngModel)]="objprof.wkcompany" #wkcompany="ngModel" type="text" placeholder="Worked Company" />
                  
                  </div>
                  <div class="row"><div class="col-md-6"> <div class="form-group ">
                    <label for="inputName" >Work Experience</label>
                    
                    <input class="form-control" name="wkexp" [(ngModel)]="objprof.wkexp" #wkexp="ngModel" type="number" placeholder="Work Experience" />
                  
                  </div></div><div class="col-md-6"> <div class="form-group ">
                    <label for="inputName" >Designation</label>
                    
                    <input class="form-control" name="wkdesig" [(ngModel)]="objprof.wkdesig" #wkdesig="ngModel" type="text" placeholder="Designation" />
                  
                  </div></div></div>

                  <div class="form-group ">
                     
                    <!-- <button type="submit" class="btn btn-danger" (click)="save_profileinfo('prof')">Save Details</button> -->
           
                </div>

                 
                   
                    </div>
              



                  <!-- /.tab-pane -->
                  <div class="tab-pane" id="Pass">
                  
                        <p class="login-box-msg">You are only one step a way from your new password, recover your password now.</p>
                  
                        <form action="login.html" method="post">
                          <div class="input-group mb-3">
                            <input type="password" class="form-control" placeholder="Password">
                            <div class="input-group-append">
                              <div class="input-group-text">
                                <span class="fas fa-lock"></span>
                              </div>
                            </div>
                          </div>
                          <div class="input-group mb-3">
                            <input type="password" class="form-control" placeholder="Confirm Password">
                            <div class="input-group-append">
                              <div class="input-group-text">
                                <span class="fas fa-lock"></span>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <button type="submit" class="btn btn-primary btn-block">Change password</button>
                            </div>
                            <!-- /.col -->
                          </div>
                        </form>
                  
                     
                      
                    


                  </div>
                  <!-- /.tab-pane -->

              
                </div>
                <!-- /.tab-content -->
              </div><!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
          <div class="col-md-3">

        
            <!-- About Me Box -->
            <div class="card card-danger card-outline" *ngIf="enablejob=='YES'">
              <div class="card-header">
                <h3 class="card-title">Useful Links</h3>
              </div>
              <!-- /.card-header -->
              <div class="card-body">
                <!-- <strong><i class="fas  fa-lock mr-1"></i>Reset Password</strong>

                <p class="text-muted">
                  B.S. in Computer Science from the University of Tennessee at Knoxville
                </p> -->

                <strong> <a style="text-decoration: underline;" [routerLink]="" *ngIf="objprof.optplacement=='NO'" (click)="confirm_register('YES')"><i class="fa fa-check mr-1"></i>Register For Placement</a></strong>
                <strong> <a style="text-decoration: underline;" [routerLink]="" *ngIf="objprof.optplacement=='YES'" (click)="confirm_register('NO')"><i class="fa fa-times mr-1"></i>Cancel Placement Registration</a></strong>
                <div *ngFor="let item of arrlinks">
                  <strong> <a style="text-decoration: underline;" [routerLink]="" (click)="openmodaldlg(item.clickevnt)"><i class="{{item.icon}} mr-1"></i>{{item.lnm}}</a></strong>
                  <hr>
                </div>
               
                <!-- <button class="btn btn-success btn-sm pull-right b2" tabindex="20"   (click)="openpubmodal(pubmodal)"  >
                  OPEN DIALOG
                  <i class="fa fa-save" aria-hidden="true"></i>
              </button> -->
                <hr>

                <strong><i class="fas fa-pencil-alt mr-1"></i> Update Your Skills</strong>

                <!-- <p class="text-muted">
                  B.S. in Computer Science from the University of Tennessee at Knoxville
                </p> -->
                 <hr>
                <strong><i class="far fa-file-alt mr-1"></i> Notes</strong>

                <p class="text-muted">
                  B.S. in Computer Science from the University of Tennessee at Knoxville
                </p>
               

               

              
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div><!-- /.container-fluid -->
      
      <!-- /.container-fluid -->
    </section>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->

  <ng-template   #pubmodal let-modal >
    <div class="modal-header">
      <span class="modal-title" id="modal-basic-title">  Details</span>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>

     
    </div>
    <div class="modal-body ">
        <div class="row">
            <div class="col-md-12">
                    <div class="box-body">
                        <div class="container-fluid" style="padding-left: 6px;min-height: 480px;">
                            <div class="row">
                                <div class="col-md-12 ">
                                    <div class="tsf-nav-step box-title modelwz" style="margin-left:0px;">

                                        <ul  class="gsi-step-indicator triangle gsi-style-2 gsi-transition">
                                            <li (click)="tab = 1" [ngClass]="{current:tab==1}"  data-toggle="tab" >
                                                <a>
                                                        
                                                    <span class="desc">
                                                        <label class="lab">Catalog Info</label>
                                                    </span>
                                                </a>
                                            </li>
                                           
                                            <li (click)="tab = 2" [ngClass]="{current:tab==2}" data-toggle="tab">
                                                <a>

                                                    <span class="desc">
                                                         <label class="lab">Other Info</label>
                                                    </span>
                                                </a>
                                            </li>
                                           
                                        </ul>

                                    </div>
                                </div>
                            </div>
                            <div class="row"  *ngIf="tab===1" >
                                <div class="wave nregfrm col-md-12">
                                    <div class="box-body">
                                      
                                        <form>
                                            <div class="col-sm-12 col-md-6 ">

                                               
                                                  <div class="feildsmargin">
                                                    <label  class="form-label">Co-Author
                                                    </label>
                                                    <input class="form-control" name="author" [(ngModel)]="pmodel.author" #author="ngModel" type="text" placeholder="Author" />
                                                   
                                                  </div>
                                                <div class="feildsmargin">
                                                  <label class="form-label"> Title</label>
                                                  <input class="form-control" name="title" type="text" [(ngModel)]="pmodel.title" #title="ngModel" placeholder=" Title" />
                                                </div>
                                                 
                                                 
                                                 

                                                  <div class="feildsmargin">
                                                    <label  class="form-label">Subject
                                                    </label>
                                                   
                                                  
                                                    <input class="form-control" name="subnm" type="text" [(ngModel)]="pmodel.subnm" #subnm="ngModel" placeholder="Subject" />

                                                  
                                                 
                                                  
                                                </div></div>
                                            <div class="col-sm-12 col-md-6 ">
                                               
                                                <div class="feildsmargin">
                                                    <label  class="form-label">Department
                                                    </label>
                                                    <!-- <select class="form-control" name="depid" [(ngModel)]="pmodel.depid" #depid="ngModel">
                                                       
                                                        <option [ngValue]="k.bkdepid" *ngFor="let k of depts">
                                                            {{k.bkdepnm}}
                                                          </option>
                                                    </select> -->

                                                    <input class="form-control" name="stfdepnm" type="text" [(ngModel)]="pmodel.stfdepnm" #stfdepnm="ngModel" placeholder="Department" />
                                                  
                                                  </div>
                                                <div class="feildsmargin">
                                                    <label  class="form-label">Publisher
                                                    </label> 
                                                    <input class="form-control" name="pubnm" type="text" [(ngModel)]="pmodel.pubnm" #pubnm="ngModel" placeholder="Publisher" />
                                                    
                                                  </div>
                                                 
                                                  

                                                  <div class="feildsmargin">
                                                    <label  class="form-label" >Name of the Source
                                                    </label>


                                                    <input class="form-control" name="sourcename" [(ngModel)]="pmodel.sourcename" #sourcename="ngModel" type="text" placeholder="Name of the Source" />
                                                    
                                                   
                                                    
                                                  </div> 
                                                    
                                              </div> 
                                         </form>
                                    </div>
                                    
                                    <div class=" foot  " >
                                        <button class="btn bg-pink btn-sm pull-right b2" tabindex="6" (click)="tab=2"  >
                                            Next
                                             <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
                                        </button>
                                    </div>

                                </div>
                            </div>
                         
                            <div class="row" *ngIf="tab===2" >
                                <div class="wave nregfrm col-md-12 ">
                                    <div class="box-body">
                                        <form>
                                            <div class="col-sm-12 col-md-6 ">
                   
                                                  <div class="feildsmargin">
                                                    <label  class="form-label">Published Place
                                                    </label>
                                                    <input class="form-control" name="pplace" [(ngModel)]="pmodel.pplace" #pplace="ngModel" type="text" placeholder="Published Place" />
                                                  </div>
                                               
                                                  <div class="feildsmargin">
                                                    <label  class="form-label">Published Year
                                                    </label>
                                                    <input class="form-control" name="pyear" [(ngModel)]="pmodel.pyear" #pyear="ngModel" type="text" placeholder="Year" />
                                                  </div>

                                                  <div class="feildsmargin">
                                                    <label  class="form-label">Published Month
                                                    </label>
                                                    <input class="form-control" name="pmonth" [(ngModel)]="pmodel.pmonth" #pmonth="ngModel" type="text" placeholder="Month" />
                                                  </div>
                                                
                                                  <div class="feildsmargin">
                                                    <label  class="form-label">ISBN/ISSN
                                                    </label>
                                                    <input class="form-control" name="issnno" [(ngModel)]="pmodel.issnno" #issnno="ngModel" type="text" placeholder="ISBN/ISSN" />
                                                  </div>
                                              

                                                  
                                                </div>
                                            <div class="col-sm-12 col-md-6 ">
                                               
                                                <div class="feildsmargin">
                                                    <label  class="form-label">Volume
                                                    </label>
                                                    <input class="form-control" name="volume" [(ngModel)]="pmodel.volume" #volume="ngModel" type="text" placeholder="volume" />
                                                  </div>
                                              
                                                  <div class="feildsmargin">
                                                    <label  class="form-label">Issue No.
                                                    </label>
                                                    <input class="form-control" name="issueno" [(ngModel)]="pmodel.issueno" #issueno="ngModel" type="text" placeholder="issueno" />
                                                  </div>

                                                  <div class="feildsmargin">
                                                    <label  class="form-label">DOI
                                                    </label>
                                                    <input class="form-control" name="DOI" [(ngModel)]="pmodel.DOI" #DOI="ngModel" type="text" placeholder="DOI" />
                                                  </div>


                                                  <div class="feildsmargin">
                                                    <label  class="form-label">Indexed In
                                                    </label>
                                                    <input class="form-control" name="pindex" [(ngModel)]="pmodel.pindex" #pindex="ngModel" type="text" placeholder="Indexed In" />
                                                  </div>
                                           
                                              </div> 
                                         </form>
                                    </div>
                                    <div class="foot" style="left: 23px;" >
                                        


                                        <!-- <button class="btn btn-success btn-sm pull-right b2" tabindex="20" *ngIf="oprtype=='insert'" (click)="openbulkdialog(copiesmodal)"  >
                                            Save 
                                            <i class="fa fa-save" aria-hidden="true"></i>
                                        </button> -->
                                        <button class="btn btn-success btn-sm pull-right b2" tabindex="20"   >
                                            Save
                                            <i class="fa fa-save" aria-hidden="true"></i>
                                        </button>

                                       


                                        <button class="btn btn-default btn-sm pull-right bkrght b2" (click)="tab=3">
                                            <i class="fa fa-chevron-circle-left" aria-hidden="true"></i> Back
                                        </button>
                                    </div>
                                </div>
                             
                            </div>
                           

                        </div>
                    </div>

               
            </div>
        </div>
    </div>
    
  </ng-template>

  <ng-template   #workmdl let-modal >
    <div class="modal-header">
      <span class="modal-title" id="modal-basic-title"> Work Experience Details</span>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>

     
    </div>
    <div class="modal-body ">
        <div class="row">
            <div class="col-md-12">
                    <div class="box-body">
                        <div class="container-fluid" style="padding-left: 6px;min-height: 200px;">
                            

                        </div>
                    </div>

               
            </div>
        </div>
    </div>
    
  </ng-template>

  <ng-template   #edumdl let-modal >
    <div class="modal-header">
      <span class="modal-title" id="modal-basic-title"> Education Details</span>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>

     
    </div>
    <div class="modal-body ">
        <div class="row">
            <div class="col-md-12">
                    <div class="box-body">
                        <div class="container-fluid" style="padding-left: 6px;min-height: 200px;">
                            

                        </div>
                    </div>

               
            </div>
        </div>
    </div>
    
  </ng-template>

  <ng-template   #proupload let-modal >
    <div class="modal-header">
      <span class="modal-title" id="modal-basic-title"> Upload Profile Document</span>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>

     
    </div>
    <div class="modal-body ">
        <div class="row">
            <div class="col-md-12">
                    <div class="box-body">
                        <div class="container-fluid" style="padding-left: 6px">
                          <div class="row">
                            <div class="col-sm-12">
                             
                                <label class="btn btn-success" for="my-file-selector">
                                    <input id="my-file-selector" type="file" style="display:none" accept="application/pdf,application/msword,
                                    application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                    onchange="$('#upload-file-info').html(this.files[0].name)" (change)="upload($event.target.files)" single>
                                    Browse File
                                    
                                </label> &nbsp;&nbsp;
                                <span  id="upload-file-info">No file selected.</span></div>
                                </div> 

                        </div>
                    </div>

               
            </div>
        </div>
        <div class="modal-footer"> <button class="btn btn-primary btn-round commandbtn " [disabled]="disuploadbtn==true"  (click)="fileupload()" >
          <i class="fa fa-upload" aria-hidden="true"></i>Upload</button></div>
    </div>
    
  </ng-template>

  <ng-template   #hobmdl let-modal >
    <div class="modal-header">
      <span class="modal-title" id="modal-basic-title"> Hobbies/Achievements</span>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body ">
        <div class="row">
            <div class="col-md-12">
                    <div class="box-body">
                        <div class="container-fluid" style="padding-left: 6px;min-height: 200px;">
                          <div class="form-group ">
                            <label for="inputExperience" >Hobbies/Co-Curricular Activities</label>
                           
                            <textarea  rows="2" class="form-control" name="hob" [(ngModel)]="objhob.hob" #hob="ngModel"    placeholder="Hobbies/Co-Curricular Activities"></textarea>
                           
                          </div>

                          <div class="form-group ">
                            <label for="inputExperience" >Achievements</label>
                           
                            <textarea  rows="2" class="form-control" name="Achievements" [(ngModel)]="objhob.achievements" #Achievements="ngModel"    placeholder="Achievements"></textarea>
                           
                          </div>

                          <div class="form-group ">
                            <label for="inputExperience" >Goals</label>
                           
                            <textarea  rows="2" class="form-control" name="Goals" [(ngModel)]="objhob.goals" #Goals="ngModel"    placeholder="Goals"></textarea>
                           
                          </div>

                          <div class="form-group ">
                            <label for="inputExperience" >Carrier Options</label>
                           
                            <textarea  rows="2" class="form-control" name="caropt" [(ngModel)]="objhob.caropt" #caropt="ngModel"    placeholder="Carrier Options"></textarea>
                           
                          </div>

                          <div class="form-group ">
                            <label for="inputExperience" >
                              Language(s) To Speak</label>
                           
                            <textarea  rows="2" class="form-control" name="lanspeak" [(ngModel)]="objhob.lanspeak" #lanspeak="ngModel"    placeholder="Language(s) To Speak"></textarea>
                           
                          </div>

                          <div class="form-group ">
                            <label for="inputExperience" >
                              Language(s) To Read</label>
                           
                            <textarea  rows="2" class="form-control" name="lanread" [(ngModel)]="objhob.lanread" #lanread="ngModel"    placeholder="Language(s) To Read"></textarea>
                           
                          </div>

                          <div class="form-group ">
                            <label for="inputExperience" >
                              Language(s) To Write</label>
                           
                            <textarea  rows="2" class="form-control" name="lanwrite" [(ngModel)]="objhob.lanwrite" #lanwrite="ngModel"    placeholder="Language(s) To Write"></textarea>
                           
                          </div>

                          <div class="form-group ">
                            <button type="submit" class="btn btn-danger">Submit</button>
                           
                          </div>

                        </div>
                    </div>

               
            </div>
        </div>
    </div>
    
  </ng-template>